export const revealConfig = {
  threshold: 0.15,
  duration: 600,
  distance: 40,
  easing: "ease",
};

export const counterConfig = {
  steps: 50,
  interval: 30,
};